<template>
  <div @dragstart.prevent :class="[size ? 'z-num-' + size : '']">
    <div class="number-input start" v-if="currentValue == 0" ref="hoverBox" @click="decrease('one')"><span>兑换礼品</span></div>
    <div class="number-input" v-else>
      <i class="icon-cut" v-if="addLoading != productCode" @click="increase">-</i>
      <i class="icon-cut" v-else><img src="../assets/load.gif" /></i>
      <input 
      :value="value"
      maxlength="10"
      @blur="handleBlur"
      @focus="handleFocus"
      @input="handleInput"
      @change="handleInputChange"
      @click="handSel">
      <i v-if="addLoading != productCode" class="icon-add" ref="hoverBox" @click="decrease('add')">+</i>
      <i v-else class="icon-add" ref="hoverBox"><img src="../assets/load.gif" /></i>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "InputNum",
  props: {
    max: {
      type: Number,
      default: Infinity
    },
    productCode: String,
    tag: {
      type: String,
      default: 'one'
    },
    min: {
      type: Number,
      default: -Infinity
    },
    value: Number,
    size: String,
    disabled: Boolean
  },
  data() {
    return {
      currentValue: this.value || 0,
      old: this.value || 0
    };
  },
  watch: {
    currentValue: {
      immediate: true,
      handler(value, oldVal) {
        let newVal = value === undefined ? value : Number(value);
        if (newVal !== undefined) {
          if (isNaN(newVal)) {
            this.currentValue = oldVal;
            return;
          }
        }
        this.currentValue = newVal;
        this.$emit("input", newVal);
        this.$emit("change", newVal, oldVal);
      }
    },
    value:{
      immediate: true,
      handler(value) {
        this.currentValue = value || 0
      }
    }
  },
  computed: {
    ...mapGetters(["addLoading","shopInfo"])
  },
  methods: {
    handSel(e){
      e.target.select()
    },
    increase() {
      if (this.addLoading) return;
      const value = this.currentValue || 0;
      const newVal = value - 1;
      
      this.setCurrentValue(newVal);
    },
    decrease(o) {
      if (this.addLoading) return;
      const self = this
      const value = this.currentValue || 0;
      const newVal = value + 1;
      const h = document.documentElement.clientHeight || document.body.clientHeight;
      self.$store.dispatch('OFFSET', {x: this.$refs.hoverBox.getBoundingClientRect().right - 30,y: h - this.$refs.hoverBox.getBoundingClientRect().bottom})
      self.setCurrentValue(newVal,o);
    },
    handleBlur(event) {
      this.$emit("blur", event);
      
      if (this.addLoading) return;
      
      const value = event.target.value;
      let newVal = value === "" ? 0 : Number(value);

      const old = Number(this.old)
      if (old > this.max ) this.old = old;
      if (old > this.min ) this.old = old;
      if (newVal > this.max) newVal = old;
      if (newVal < this.min) newVal = old;
      this.currentValue = newVal
      
      if (newVal == 0) {
        this.delData()
      } else {
          this.putData (newVal)
      }
    },
    handleFocus(event) {
      this.$emit("focus", event);
      this.old = event.target.value;
    },
    setCurrentValue(newVal,o) {
      const oldVal = this.currentValue;
      if (newVal >= this.max) newVal = this.max;
      if (newVal <= this.min) newVal = this.min;
      if (oldVal === newVal) return;
      if (newVal == 0) {
        this.delData()
      } else if(o == 'one') {
        this.getData(1)
      } else {
        this.putData (newVal,o)
      }
      this.$emit("input", newVal);
      this.currentValue = newVal;
    },
    handleInput(event) {
      this.currentValue = event.target.value;
      if (Number(event.target.value) == 0 || this.currentValue == '' ) {
        this.delData()
      }

    },
    handleInputChange() {
    },
    getData (quantity){
      this.$store.dispatch("ADDCARTS",{ productCode: this.productCode, merchantCode: this.shopInfo.merchantCode, quantity: quantity, tag: this.tag }).then( res => {
        if (res.data.recode != 200) {
          this.$emit("input", 0);
          this.$alert(res.data.msg || res.data.recode, '提示')
        } else {
          this.old = quantity
        }
      });
    },
    putData (quantity, animation) {
      this.$store.dispatch("PUTCARTS",{ productCode: this.productCode, merchantCode: this.shopInfo.merchantCode, quantity: quantity, animation: animation, tag: this.tag }).then( res => {
        if (res.data.recode != 200) {
          this.$emit("input", Number(this.old));
          this.$alert(res.data.msg || res.data.recode, '提示')
        } else {
          this.old = quantity
        }
      }); 
    },
    delData () {
      this.$store.dispatch("DELCARTS",{ merchantCode: this.shopInfo.merchantCode, productCode: this.productCode, tag: this.tag }).then( res => {
        if (res.data.recode != 200) {
           this.$emit("input", Number(this.old));
          this.$alert(res.data.msg || res.data.recode, '提示')
        }
      }); 
    }
  }
};
</script>
<style>
.number-input {
  border: 2px solid #ed6c00;
  display: inline-block;
  border-radius: 60px;
  height: 36px;
  width: 120px;
  text-align: center;
  font-size: 16px;
  overflow: hidden;
  padding: 0;
  outline: 0;
  color: #ed6c00;
}
.number-input.start {
  cursor: pointer;
  border: 2px solid #ed6c00;
}
.number-input.start span {
  line-height: 36px;
  line-height: 32px\0;
  font-size: 16px;
  color: #ed6c00;
  vertical-align: top;
}
.number-input .icon-add,
.number-input .icon-cut {
  user-select: none;
  cursor: pointer;
  float: left;
  width: 40px;
  line-height: 36px;
  text-align: center;
  font-size: 26px;
  background: #f8f8f8;
  font-style: normal;
  font-family: "\5B8B\4F53";
  border-radius: 38px;
  border: 2px solid #ed6c00;
  margin: 0;
  margin-top: -2px;
  font-weight: bold;
}
.number-input .icon-add img,
.number-input .icon-cut img{
  vertical-align: 2px;
}
.number-input .icon-add {
  border-right: none;
  float: right;
}
.number-input .icon-cut {
  border-left: none;
}
.number-input input {
  float: left;
  width: 32px;
  width: 32px\0;
  height: 36px;
  line-height: 36px;
  height: 32px\0;
  line-height: 32px\0;
  text-align: center;
  color: #333;
  border: none;
  font-size: 18px;
}
/* mini */
.z-num-mini .number-input {
  height: 26px;
  width: 90px;
}
.z-num-mini .number-input.start span {
  line-height: 26px;
  line-height: 22px\0;
  font-size: 14px;
}
.z-num-mini .number-input .icon-add,
.z-num-mini .number-input .icon-cut {
  width: 28px;
  line-height: 26px;
}
.z-num-mini .number-input input {
  width: 26px;
  width: 26px\0;
  height: 26px;
  line-height: 26px;
  line-height: 22px\0;
  font-size: 14px;
}
</style>
